const BASE_PATH = "app/search/";

export const SET_SEARCH = `${BASE_PATH}set-search`;
export const CLEAR_SEARCH_RESULT = `${BASE_PATH}set-search-result`;
export const UPDATE_SCROLL_HEIGHT = `${BASE_PATH}set-search-scroll-height`;
export const UPDATE_SEARCH_FILTER = `${BASE_PATH}set-search-filter`;
